export const AUDIENCE_ALLOWLIST = ['AI'] as const;
export type AudienceToken = (typeof AUDIENCE_ALLOWLIST)[number];

const SESSION_STORAGE_KEY = 'playcast_audience';

export function isValidAudience(token: string): token is AudienceToken {
  return AUDIENCE_ALLOWLIST.some(
    (allowed) => allowed.toLowerCase() === token.toLowerCase(),
  );
}

export function getCanonicalToken(token: string): AudienceToken | null {
  const match = AUDIENCE_ALLOWLIST.find(
    (allowed) => allowed.toLowerCase() === token.toLowerCase(),
  );
  return match ?? null;
}

export function getStoredAudience(): AudienceToken | null {
  try {
    const stored = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (stored && isValidAudience(stored)) {
      return getCanonicalToken(stored);
    }
  } catch {
    // sessionStorage unavailable (SSR, private browsing edge cases)
  }
  return null;
}

export function storeAudience(token: AudienceToken): void {
  try {
    sessionStorage.setItem(SESSION_STORAGE_KEY, token);
  } catch {
    // silent fail
  }
}

export function clearStoredAudience(): void {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  } catch {
    // silent fail
  }
}

export { SESSION_STORAGE_KEY };

interface SwapSlot {
  default: string;
  replacement: string;
}

export const SWAP_MAP: Record<AudienceToken, Record<string, SwapSlot>> = {
  AI: {
    'hostlanding-hero-reward-line': {
      default: 'YOU EARN REWARDS',
      replacement: 'YOU GET AI TOKENS',
    },
    'howitworks-step2-asset': {
      default: '/img/aida/icon-host-playcasts.png',
      replacement: '/img/aida/icon-host-playcasts-ai.png',
    },
    'hostthreeplatform-s3-body': {
      default:
        'While powering the Playcast network, earn tokens and unlock rewards. As the network grows, so does the reward pool: new games, new perks, and exclusive community events.',
      replacement:
        'While powering the Playcast network, earn tokens and unlock rewards. As the network grows, so does the offerings: new rewards, extra perks, and exclusive community events.',
    },
  },
};
